import login from 'app/features/authentication/analytics/login';
import registration from 'app/features/authentication/analytics/registration';

const authentication = { ...login, ...registration };

export default authentication;
